import { render, staticRenderFns } from "./product-detail-floor-1.vue?vue&type=template&id=44df41bd&scoped=true"
import script from "./product-detail-floor-1.vue?vue&type=script&lang=js"
export * from "./product-detail-floor-1.vue?vue&type=script&lang=js"
import style0 from "./product-detail-floor-1.vue?vue&type=style&index=0&id=44df41bd&prod&lang=css"
import style1 from "./product-detail-floor-1.vue?vue&type=style&index=1&id=44df41bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df41bd",
  null
  
)

export default component.exports